import CityPageTemplate from "../city-template/CityPageTemplate";
import { concordConfig } from "./data";

export default function ConcordPage() {
  return <CityPageTemplate config={concordConfig} />;
}